export const symbolUIStrings = {
  centerDot: '·',
  percentage: '%',
  tilde: '~',
  dollar: '$',
  plus: '+',
  minus: '-',
  infinity: '∞',
  doubleRightArrow: '››',
  doubleLeftArrow: '‹‹',
  rightArrow: '›',
  leftArrow: '‹',
  pipe: '|',
  plusMinus: '±',
};
